"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.settingsConnectionsTabs = void 0;
exports.settingsConnectionsTabs = {
    services: {
        text: "Services",
        value: "services",
    },
    personalData: {
        text: "Personal data",
        value: "personal data",
    },
};
